import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { PostCommentContainerModel } from '../../../../../models/aggregates/post-comment';
import { Observable } from 'rxjs';
import { PagingResponseModel } from '../shared/api-response.model';
import { ApiVisa, Pagination } from '../shared';

@Injectable({
  providedIn: 'root'
})
export class PostCommentService extends BaseApiTemplateService<PostCommentContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post-comments';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post-comments';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post-comments';
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post-comments/' + BaseApiTemplateService.LOGIN_ENTITY_EP;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post-comments/' + BaseApiTemplateService.PUBLIC_EP;
    this.httpClient = http;
  }

  getPostCommentsByCriteriaPublic(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<PostCommentContainerModel>>{
    const publicApiUrl = visa.api_domain_url ?
    visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post-comments/get-user-comment/' + BaseApiTemplateService.PUBLIC_EP
    : Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post-comments/get-user-comment/' + BaseApiTemplateService.PUBLIC_EP;
    return this.__getByCriteriaAux<PostCommentContainerModel>(publicApiUrl, pagination, visa);
  }

}


